<template>
  <PagesMenu v-if="activePanel === -1" />
  <CourseEditLeftPanel v-else-if="activePanel === 1" />
</template>

<script>
import PagesMenu from '@/components/manage/PagesMenu.vue';
import { trainingsMode } from '@/shared/enums';
import CourseEditLeftPanel from '@/components/manage/courses/CourseEditLeftPanel.vue';
import { createNamespacedHelpers } from 'vuex';

const { mapState } = createNamespacedHelpers('courses');

export default {
  components: {
    PagesMenu,
    CourseEditLeftPanel
  },
  computed: {
    ...mapState(['activeMode']),
    activePanel() {
      switch (this.activeMode) {
        case trainingsMode.NewCourse:
        case trainingsMode.EditCourse:
          return 1;
        case trainingsMode.ViewCourse:
          return 2;
        default:
          return -1;
      }
    }
  }
};
</script>
